import qs from 'qs'

const defaultOpts = { arrayFormat: 'brackets' }
export const stringifyParams = (params, opts = {}) =>
  qs.stringify(params, { ...defaultOpts, ...opts })
